module.exports = __webpack_public_path__ + "static/img/learning_resource_item.21ade3d4.png";